import inlineSVG from 'inline-svg'

document.addEventListener('DOMContentLoaded', function() {
  inlineSVG.init({
    svgSelector: 'img.svg',
    initClass: 'js-inlinesvg',
  })
})
